// extracted by mini-css-extract-plugin
export var cursor = "Cursor-module--cursor--RczSj";
export var isDark = "Cursor-module--isDark--ZF5s6";
export var showBackground = "Cursor-module--showBackground--MUpfz";
export var inner = "Cursor-module--inner--kHtfG";
export var char = "Cursor-module--char--E6viW";